<template>
	<!-- STATS -->
	<div class="card mb-4" style="width:100%">
		<div class="card-header">
			<div class="form-row">
				<div class="col-md-6">
					<label> 
						{{$t('charts.typeStat')}}
					</label>
					<select v-model="typeStat" @change="handleChange" class="form-control">
						<option v-for="stat in typeStats" :value="stat.id" :key="stat.id">
							{{ stat.label}}
						</option>
					</select>
				</div>
				<div class="col-md-6">
					<label> 
						{{$t('charts.list')}}
					</label>
					<select v-model="typeChart" class="form-control">
						<option v-for="chart in typeCharts" :value="chart" :key="chart">
							{{$t('charts.'+chart)}}
						</option>
					</select>
				</div>

			</div>
		</div>
		<div class="card-body">
			<div class="overflow-auto">
				<g-chart css-classes="chart-pie"
					:type="typeChart"
					:options="chartOptions"
					:data="chartData"
				/>
			</div>
		</div>
	</div>
</template>
<script>
	import { GChart } from "vue-google-charts";
	export default {
		name: "chart",
		components: {
			'g-chart': GChart
		},
		props: {
			chartData: {
				type: Array,
				required: true
			},
			typeStats: {
				type: Array,
				required: true
			},
			chartOptions: {
				type: Object,
				required: false,
				default: () => ({
					width: 'auto',
					height: 500,
					language: 'fr',
					is3D: true
				})
			},
		},
		data() {
			return {
				/*chartOptions: {
					width: 'auto',
					height: 500,
					language: 'fr',
					hAxis: {title: 'Désignation'},
					vAxis: {title: 'Montant / Quantié'},
					title: 'Statistique',
					is3D: true
				},*/
				// chartData: [],
				titlePref: 'Statistique par ',
				typeChart: 'ColumnChart',
				typeCharts: process.env.VUE_APP_TYPE_CHARTS.split(","),
				typeStat: '',
		
			}
		},
		updated() {
		},
		mounted() {
			// add default values
			Object.assign(this.chartOptions, {
				width: 'auto',
				height: 500,
				language: 'fr',
				is3D: true
			});
			if(this.chartOptions.title && this.chartOptions.title != '')
				this.titlePref = this.chartOptions.title;

			if(this.typeStats && this.typeStats[0] && this.typeStats[0].id){
				this.typeStat = this.typeStats[0].id;
				this.chartOptions.title = this.titlePref + this.typeStats[0].label
			}
		},
		methods:{
			handleChange(event) {
				let typeSelected = this.typeStats.filter(item => item.id == this.typeStat)[0]
				this.chartOptions.title = this.titlePref + typeSelected.label
				this.$emit('refreshChart', this.typeStat);
			},
		}

	}
</script>